export const ColorSpace = [
    'COLORSPACE_LINEAR',
    'COLORSPACE_SRGB',
];
